module.exports = __webpack_public_path__ + "media/images/icon_list/chevron_left-4eac6d57d2eb78e6763cb61366417e2f.svg";